import { useMutation } from "react-query";

import reservationsService from "api/reservationsService";
import { ICancelReservationURLParams } from "types/reservation";

const useCancelReservationMutation = ()=> {
  return useMutation(async(params: ICancelReservationURLParams) => {
    try {
      const res = await reservationsService.cancelReservation(params)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useCancelReservationMutation